module.exports = __webpack_public_path__ + "img/hospital12.255cbdd6.png";